<template>
    <div class="filter-time-row input-row">
        <label :for="uniqueId" class="input-label full-width">{{ label }}</label>
        <duet-date-picker :identifier="uniqueId"
                          :localization.prop="currentLocalization"
                          :value="dateString"
                          :dateAdapter.prop="adapter"
                          @duetChange="changeAndReturnDate">
        </duet-date-picker>
        <img ID="CalendarImage" Class="custom-calendar-image" v-bind:src="dateIconUrl" />
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"

    @Component
    export default class DatePicker extends Vue {
        @Prop(String) date: string | undefined
        @Prop(String) uniqueId: string | undefined // Must be unique between instances
        @Prop(String) label: string | undefined

        dateString: string = ""

        get dateIconUrl(): string {
            const now = new Date()
            const timeStamp = now.getFullYear() +
                (now.getMonth() + 1).toString().padStart(2, "0") +
                now.getDate().toString().padStart(2, "0") +
                now.getHours().toString().padStart(2, "0")
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg/kalenteri.svg" + "?" + timeStamp
        }

        // Adapter that converts date between internal and external formats.
        get adapter(): Record<string, unknown> {
            const DATE_FORMAT = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/
            return {
                parse(value = "", createDate: any) {
                    const matches = value.match(DATE_FORMAT)
                    if (matches) {
                        return createDate(matches[3], matches[2], matches[1])
                    }
                },
                format(date: Date) {
                    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
                }
            }
        }

        get currentLocalization(): Record<string, unknown> | undefined {
            return {
                buttonLabel: this.$t("App.DatePicker.buttonLabel"),
                placeholder: this.$t("App.DatePicker.placeholder"),
                selectedDateMessage: this.$t("App.DatePicker.selectedDateMessage"),
                prevMonthLabel: this.$t("App.DatePicker.prevMonthLabel"),
                nextMonthLabel: this.$t("App.DatePicker.nextMonthLabel"),
                monthSelectLabel: this.$t("App.DatePicker.monthSelectLabel"),
                yearSelectLabel: this.$t("App.DatePicker.yearSelectLabel"),
                closeLabel: this.$t("App.DatePicker.closeLabel"),
                keyboardInstruction: this.$t("App.DatePicker.keyboardInstruction"),
                calendarHeading: this.$t("App.DatePicker.calendarHeading"),
                dayNames: this.$t("App.DatePicker.dayNames")?.split(/, */),
                monthNames: this.$t("App.DatePicker.monthNames")?.split(/, */),
                monthNamesShort: this.$t("App.DatePicker.monthNamesShort")?.split(/, */),
                locale: this.$t("App.DatePicker.locale")
            }
        }

        changeAndReturnDate(e: CustomEvent): void {
            this.dateString = e.detail.value
            if (this.dateString === "") {
                this.$emit("newDate", null)
            } else {
                this.$emit("newDate", this.dateString)
            }
        }
    }
</script>

<style scoped>
    .datetime-div {
        margin-bottom: 20px;
        display: inline-block;
    }

    .full-width {
        width: 100%;
    }
</style>
<style>
    /* DuetDate styles */
    :root {
        --duet-color-primary: #026273;
        --duet-color-text: #333;
        --duet-color-text-active: #fff;
        --duet-color-placeholder: #666;
        --duet-color-button: #f5f5f5;
        --duet-color-surface: #fff;
        --duet-color-overlay: rgba(0, 0, 0, 0.8);
        --duet-color-border: #333;
        --duet-font: Open sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        --duet-font-normal: 400;
        --duet-font-bold: 600;
        --duet-radius: 2px;
        --duet-z-index: 1003;
    }

    div.duet-date {
        display: inline-flex;
        height: 50px;
        width: 300px;
        max-width: 58.333333%;
    }

    button.duet-date__toggle {
        margin-top: 1.2px;
        margin-right: 0.5px;
        height: calc(100% - 2.5px);
    }

    .duet-date__dialog {
        top: unset;
        bottom: 100%;
    }

    .duet-date input.duet-date__input {
        font-size: 1rem;
    }

        .duet-date input.duet-date__input:focus {
            border-width: 1px;
            border-color: #026273;
            box-shadow: 1px 1px inset #026273, -1px -1px inset #026273;
        }

    .duet-date span.duet-date__toggle-icon {
        display: none;
    }

    .custom-calendar-image {
        position: absolute;
        margin-top: 12px;
        margin-left: -40px;
        height: 30px;
        vertical-align: middle;
        pointer-events: none;
        z-index: 1002;
    }

    .duet-date__dialog-content {
        padding-top: 30px;
    }

    .duet-date__mobile {
        width: 100%;
        padding: 0px 16px;
        margin: 16px 0px;
    }

    td.duet-date__cell {
        padding: 0;
        border: 0;
    }
</style>
